import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { IListModel } from "../Models/UI/IListModel";

interface IListsSettingsContainerProps {
    Model: IListModel;
    id?: string;
    className?: string;
}

class ListsSettingsContainer extends BaseReactComponent<IListsSettingsContainerProps> {
    public componentDidMount(): void {
        super.setOverlay("ListsSettingsContainer", { transparent: true });
    }

    public render(): JSX.Element {
        return (
            <div
                id={this.props.id}
                className={this.props.className}
                style={{ maxWidth: "500px" }}
            >
                <SearchSettingsFooter
                    onClose={() => sessionStore.dispatch(LocalOperations.Lists.SearchSettings_CancelClick)}
                    onOk={() => sessionStore.dispatch(LocalOperations.Lists.SearchSettings_OkClick)}
                    onColumnOrderingButtonClick={() => sessionStore.dispatch(LocalOperations.Lists.SearchSettings_ColumnOrderingPopup_Open)}
                    onResultsPerPageChange={value => sessionStore.dispatch(LocalOperations.Lists.SearchSettings_OnResultsPerPageChange, { value })}
                    selectedPageSizeOption={this.props.Model.get("SelectedPageSizeOption")}
                    pageSizeOptions={this.props.Model.get("PageSizeOptions").toArray()}
                />
            </div>
        );
    }
}

export { ListsSettingsContainer };
